
const campaignDetailMeta = {
  pageTitle: 'Paylaşımlar',
  pageIcon: 'DollarSignIcon',
  requiresAuth: true,
  breadcrumb: [
    {
      text: 'Paylaşım Detay',
      active: true,
    },
  ],
};

export default [
  {
    path: '/bio/:key',
    name: 'bio',
    component: () => import('@/views/company/Bio.vue'),
    meta: {
      pageTitle: 'Bio Link',
      pageIcon: 'HomeIcon',
    },
  },
  {
    path: '/bio/:key/:platform_id',
    name: 'bio-platform',
    component: () => import('@/views/company/BioPlatform.vue'),
    meta: {
      pageTitle: 'Bio Platform',
      pageIcon: 'HomeIcon',
      breadcrumb: [
        {
          text: 'Bio',
          to: { name: 'bio' },
        },
        {
          text: 'Platform',
          active: true,
        },
      ],
    },
  },{
    path: '/bio/:key/:platform_id/:id',
    name: 'bio-detail',
    component: () => import('@/views/campaign/CampaignDetail.vue'),
    meta: {
      pageTitle: 'Bio Detay',
      pageIcon: 'HomeIcon',
      breadcrumb: [
        {
          text: 'Bio',
          to: { name: 'bio' }
        },
        {
          text: 'Platform',
          to: {
            name: 'bio-platform',
            params: { key: window.location.pathname.split('/')[2], platform_id: window.location.pathname.split('/')[3] }
          }
        },
        {
          text: 'Detay',
          active: true
        }
      ]
    }
  },
  {
    path: '/bio/detail/:id',
    name: 'bio-detail',
    component: () => import('@/views/campaign/CampaignDetail.vue'),
    meta: campaignDetailMeta,
  },
  {
    path: '/company/story',
    name: 'story',
    component: () => import('@/views/company/StoryList.vue'),
    meta: {
      pageTitle: 'Story Takibi',
      pageIcon: 'InstagramIcon',
    },
  },
  {
    path: '/company/sms',
    name: 'sms',
    component: () => import('@/views/company/SmsList.vue'),
    meta: {
      pageTitle: 'Sms Takibi',
      pageIcon: 'MessageSquareIcon',
    },
  },
  {
    path: '/company/whatsapp',
    name: 'whatsapp',
    component: () => import('@/views/company/WhatsappList.vue'),
    meta: {
      pageTitle: 'Whatsapp Takibi',
      pageIcon: 'MessageCircleIcon',
    },
  },
  {
    path: '/company/sms/:id',
    name: 'sms-detail',
    component: () => import('@/views/campaign/CampaignDetail.vue'),
    meta: {
      ...campaignDetailMeta,
      navActiveLink: 'sms',
    },
  },
  {
    path: '/company/whatsapp/:id',
    name: 'whatsapp-detail',
    component: () => import('@/views/campaign/CampaignDetail.vue'),
    meta: {
      ...campaignDetailMeta,
      navActiveLink: 'whatsapp',
    },
  },
  {
    path: '/company/story/:id',
    name: 'story-detail',
    component: () => import('@/views/campaign/CampaignDetail.vue'),
    meta: {
      ...campaignDetailMeta,  
      navActiveLink: 'story',
    },
  },
  {
    path: '/company/email',
    name: 'email',
    component: () => import('@/views/company/EmailList.vue'),
    meta: {
      pageTitle: 'Email Takibi',
      pageIcon: 'MailIcon',
    },
  },
  {
    path: '/company/webpush',
    name: 'webpush',
    component: () => import('@/views/company/WebPushList.vue'),
    meta: {
      pageTitle: 'Web Push Takibi',
      pageIcon: 'BellIcon',
    },
  },
  {
    path: '/company/email/:id',
    name: 'email-detail',
    component: () => import('@/views/campaign/CampaignDetail.vue'),
    meta: {
      ...campaignDetailMeta,
      navActiveLink: 'email',
    },
  },
  {
    path: '/company/webpush/:id',
    name: 'webpush-detail',
    component: () => import('@/views/campaign/CampaignDetail.vue'),
    meta: {
      ...campaignDetailMeta,
      navActiveLink: 'webpush',
    },
  },
  {
    path: '/company/multilinks/:id',
    name: 'multi-links',
    component: () => import('@/views/campaign/MultiLinks.vue'),
    meta: {
      ...campaignDetailMeta,
      navActiveLink: 'multi-links',
    },
  },
];
